var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{class:[
        'tw:w-full tw:px-4 tw:py-3 tw:text-sm tw:text-slate-700 tw:bg-white tw:border tw:border-slate-300 tw:rounded-xl tw:shadow-sm',
        'tw:focus:outline-none tw:focus:ring-2 tw:focus:ring-primary/20 tw:focus:border-primary',
        'tw:transition-all tw:resize-y',
        _vm.customClass
    ],attrs:{"placeholder":_vm.placeholder,"rows":_vm.rows},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }